import React from 'react';
import { Helmet } from 'react-helmet';

export default function HelmetMetaData(props) {
  const currentUrl = 'https://event.hackhub.com';
  const quote = props.quote !== undefined ? props.quote : '';

  const image =
    props.image !== undefined
      ? props.image
      : '/img/general/event.png';

  const hashtag = props.hashtag !== undefined ? props.hashtag : '#HackHub';
  const title = props.isCNDomain ? '发掘你的潜在才能 | 黑咖创客赛事平台' : 'Discover the Talent in You | HackHub Event';
  const description = props.isCNDomain ? '黑咖创客是培育英才的平台。黑咖与业内精英，各大院校和科技导师合作举办线上比赛和创客松，促进人才和公司的发展。' :
    'HackHub Event is a talent incubation platform. By working with industry experts, educational institutions and incubators, HackHub facilitates the professional growth of talent and companies through online competitions and hackathons.';
  return (
    <Helmet>
      <title>{title}</title>
      <meta name='description' content={description} />
      <meta charSet='utf-8' />
      <meta httpEquiv='X-UA-Compatible' content='IE=edge' />
      <meta name='csrf_token' content='' />
      <meta property='type' content='website' />
      <meta property='url' content={currentUrl} />
      <meta
        name='viewport'
        content='width=device-width, initial-scale=1, shrink-to-fit=no'
      />
      <meta name='msapplication-TileColor' content='#ffffff' />
      <meta name='msapplication-TileImage' content='/img/general/logo.png' />
      <meta name='theme-color' content='#ffffff' />
      <meta name='_token' content='' />
      <meta name='robots' content='noodp' />
      <meta property='title' content={title} />
      <meta property='quote' content={quote} />
      <meta property='image' content={image} />
      <meta property='og:locale' content='en_US' />
      <meta property='og:type' content='website' />
      <meta property='og:title' content={title} />
      <meta property='og:quote' content={quote} />
      <meta property='og:hashtag' content={hashtag} />
      <meta property='og:image' content={image} />
      <meta content='image/*' property='og:image:type' />
      <meta property='og:url' content={currentUrl} />
      <meta property='og:site_name' content='HackHub' />
      <meta property='og:description' content={description} />
    </Helmet>
  );
}



// WEBPACK FOOTER //
// ./src/components/common/helmet.js